export default {
    user: {
        create: {
            title: "Nuovo utente",
            model: {
                email: {
                    label: "E-mail",
                    placeholder: "Compila l'email"
                },
                name: {
                    label: "Nome",
                    placeholder: "Inserisci il nome"
                },
                country: {
                    label: "Paese",
                    placeholder: "Riempi il paese"
                },
                approval_manager_email: {
                    label: "Email del responsabile",
                    placeholder: "Compila l'email del responsabile",
                    errors: {
                        different: "L'email del responsabile delle approvazioni deve essere diversa dall'email dell'utente"
                    }
                }
            },
            cta: {
                submit: {
                    text: "Invia",
                    processing: "Invio"
                },
                cancel: {
                    text: "Cancellare"
                }
            }
        },
        country: {
            title: "Paese dell'utente",
            header: "{email} non ha selezionato un paese. Seleziona il paese.",
            model: {
                country: {
                    label: "Paese",
                    placeholder: "Riempi il paese"
                }
            },
            cta: {
                submit: {
                    text: "Invia",
                    processing: "Invio"
                },
                cancel: {
                    text: "Cancellare"
                }
            }
        }
    }
}